import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { QueryOptions } from '@app/model/query-options';
import { Technology } from '@app/model/technology';
import { TechnologyAddEditService } from './technology-modal/technology-add.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-technology-add-edit',
  templateUrl: './technology-add-edit.component.html',
  styleUrls: ['./technology-add-edit.component.css'],
  providers : [TechnologyAddEditService]
})
export class TechnologyAddEditComponent implements OnInit {

  technologyList : any;
  technology : any = {
     selectedTechnology :{
      id : '',
      name : '',
      isActive : false,
      hasTemplate : false,
      addAllowed :true
     } 
    
  } ;
  isDisable : boolean = false;
  display : boolean = false;
  isEditable : boolean = false;

  constructor(
    private _api : TechnologyAddEditService,
    private _route : Router
  ) { }

  ngOnInit() {
    this.getAllTechnologies();
  }

  queryParams(sortFieldName?:string,sortOrder?:any){
    const queryParams = new Object();
    queryParams['sortParam'] = { sortField:sortFieldName , sortOrder: sortOrder };
    
    const tableSortingQueryOption = new QueryOptions(queryParams);
    tableSortingQueryOption.toQueryMap();
    return tableSortingQueryOption;
}

  redirectToDashboard()
  {
    this._route.navigate(['/home']);
  }

  showTechnologyCreation = function (bool: boolean, isEdit? : boolean) {
    this.display = bool;
    this.isEditable = isEdit;
}

setTechnologyData = function (obj: any) {
  this.technology.selectedTechnology = {
    id : '',
    name : '',
    isActive : false,
    hasTemplate : false,
    addAllowed : true
  };
  this.getAllTechnologies();
  if(this.technology.selectedTechnology && obj)
  {
    this.technology.selectedTechnology.name = obj.name;
    this.technology.selectedTechnology.id = obj.id;
    this.technology.selectedTechnology.isActive = obj.isActive;
    this.technology.selectedTechnology.addAllowed = obj.addAllowed;
    this.technology.selectedTechnology.hasTemplate = obj.hasTemplate;
  }
 
}

goToEditTemplate(isNew :boolean){
  this._route.navigate(['./template-add-edit'], {state :{ data : {technologyList:this.technologyList, technology: this.technology, newFlag: isNew, disableFlag:false} } });
}

goToPreviewTemplate(){
  this.isDisable = true;
 
  // disableFlag = true indicates preview mode
  this._route.navigate(['./template-add-edit'], {state :{ data : {technologyList:this.technologyList, technology: this.technology, disableFlag:true} } });
}

getAllTechnologies() {
  this.technologyList = [];
  var params= this.queryParams("name", 1);
  this._api.getAllTechnologies(params).subscribe((res : any) => {
    let tech = res.map( item => {
        return {
          id : item.id,
          name : item.name,
          isActive : !item.deleted,
          hasTemplate: item.templateAvailable == 0 || item.templateAvailable == null ? false:true,
          addAllowed: item.addAllowed == 0 ? false:true
        }
    });
    this.technologyList = tech;
   });
}
}
